module.exports = __webpack_public_path__ + "img/embedded2.8c8c9ef8.png";